export function normalizeCollegeCode(value: string | null | undefined) {
  return (value ?? "")
    .trim()
    .replace(/[^A-Za-z0-9\s_-]+/g, "")
    .replace(/[\s_]+/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "")
    .toUpperCase();
}

export function codesMatch(first: string | null | undefined, second: string | null | undefined) {
  return normalizeCollegeCode(first) !== "" && normalizeCollegeCode(first) === normalizeCollegeCode(second);
}
